module.exports = __webpack_public_path__ + "media/images/plus-31f6358c36bbba45bc51d75361f45582.svg";